import { PencilSimple, TrashSimple } from "@phosphor-icons/react";
import { Button } from "antd";
import { useUpdateURLSearchParams } from "hooks/useQuery";
import type { PermissionGroupDetail } from "types/permission-group";

import { TableZentake } from "@/ui/atoms/Table/TableZentake";
import Tooltip from "@/ui/atoms/Tooltip";

type Props = {
  loading: boolean;
  roles: PermissionGroupDetail[];
};

const RolesTable = ({ roles, loading }: Props) => {
  const updateParams = useUpdateURLSearchParams();
  return (
    <TableZentake.Root>
      <TableZentake.Head
        columns={[
          "NAME",
          <div className="w-full text-center" key="actions">
            ACTIONS
          </div>,
        ]}
      />

      <TableZentake.Body>
        {!roles && !loading ? (
          <TableZentake.Row>
            <TableZentake.Column>No Results Found</TableZentake.Column>
          </TableZentake.Row>
        ) : (
          roles.map((role) => (
            <TableZentake.Row key={role.id}>
              <TableZentake.Column className="w-full">
                {role.name}
              </TableZentake.Column>
              <TableZentake.Column>
                <div className="flex justify-center gap-4 w-36">
                  {role.can_edit && (
                    <Tooltip mouseEnterDelay={0.35} title="Edit">
                      <Button
                        className="w-[fit-content] !px-4"
                        onClick={() => updateParams(["editId", `${role.id}`])}
                      >
                        <PencilSimple className="text-xl" />
                      </Button>
                    </Tooltip>
                  )}
                  {role.can_delete && (
                    <Tooltip mouseEnterDelay={0.35} title="Delete">
                      <Button
                        className="w-[fit-content] !px-4"
                        onClick={() => updateParams(["deleteId", `${role.id}`])}
                      >
                        <TrashSimple className="text-xl" />
                      </Button>
                    </Tooltip>
                  )}
                </div>
              </TableZentake.Column>
            </TableZentake.Row>
          ))
        )}
      </TableZentake.Body>
    </TableZentake.Root>
  );
};

export default RolesTable;
